import { computed } from 'vue';
import { useStore } from 'vuex';
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const usePhoneField = (required, messages = {}) => {
  const validator = yup
    .string()
    .requirement(required, messages['requirement'] || '電話番号は必須項目です')
    .phoneFormat();
  const fieldName = computed(() => 'phone');

  return { validator, fieldName };
};

export const usePhoneStore = () => {
  const store = useStore();
  const phone = computed(() => store.state.formData.phone);
  const dispatcher = computed(() => 'formData/setPhone');

  return { phone, dispatcher };
};
